import { render, staticRenderFns } from "./CorrectiveBills.vue?vue&type=template&id=f01acc36&"
import script from "./CorrectiveBills.vue?vue&type=script&lang=js&"
export * from "./CorrectiveBills.vue?vue&type=script&lang=js&"
import style0 from "./CorrectiveBills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports